import { render, staticRenderFns } from "./CDNbreadcrumbs.vue?vue&type=template&id=36865f4a&scoped=true&"
import script from "./CDNbreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./CDNbreadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./CDNbreadcrumbs.vue?vue&type=style&index=0&id=36865f4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36865f4a",
  null
  
)

export default component.exports